import React, { useState } from 'react';
import classnames from 'classnames';

import './index.scss';

const MenuList = ({ section, menuItems }) => {
	const [pack, setPack] = useState([]);

	const handleSwitchToMore = (i) => {
		const newPack = [];
		newPack[i] = true;
		setPack(newPack);
	};

	const handleSwitchToLess = (i) => {
		const newPack = [];
		newPack[i] = false;
		setPack(newPack);
	};

	return (
		<div className='scroll-offset' id={section.trim()}>
			<div className='list-wrapper'>
				<div className='list-title'>
					<h2>{section}</h2>
				</div>
				<div>
					{menuItems.map((v, i) => (
						<div key={i} className='list-container'>
							<div className='list-content'>
								<h4>{v.item}</h4>
								{v.detail && (
									<div className='list-left'>
										<p
											className={classnames('list-detail', {
												active: pack[i],
											})}
										>
											{v.detail}
										</p>

										<p
											id={v.item.replace(/\s+/g, '')}
											className='switch-button'
										>
											{!pack[i] ? (
												<span onClick={() => handleSwitchToMore(i)} id='expand'>
													Show more
												</span>
											) : (
												<span onClick={() => handleSwitchToLess(i)} id='pack'>
													Show less
												</span>
											)}
										</p>
									</div>
								)}
							</div>
							<span>{`$${v.price}`}</span>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default MenuList;
